<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="pref07fig01"></a><a id="page_xxxii"><img alt="image" src="graphics/fxxxii-01.jpg"/></a><a id="page_xxxiii"></a></p><a id="page_xxxiii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// pref07.vue?1eda67b4